import { motion } from "framer-motion";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";

const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative overflow-hidden border-t border-white/10 bg-[#050505] px-6 pt-28 pb-12 md:px-12"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <img
              src="https://customer-assets-jai6qajn.emergentagent.net/job_emergency-auto-6/artifacts/xqn88ffu_Storms%20Road%20Circle.png"
              alt="Storm's Roadside logo"
              data-testid="footer-logo"
              className="mb-6 h-24 w-24 rounded-full object-cover ring-1 ring-white/15"
            />
            <p className="overline mb-6 text-primary">Storm&apos;s Roadside</p>
            <p className="max-w-sm text-lg leading-relaxed text-white/60">
              24/7 roadside and automotive service proudly serving New Orleans
              and surrounding areas.
            </p>
            <button
              data-testid="footer-back-to-top"
              onClick={scrollTop}
              className="group mt-8 flex items-center gap-2 overline text-white/70 transition-colors hover:text-primary"
            >
              Back to top
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
            </button>
          </div>

          <div className="md:col-span-4">
            <p className="overline mb-6 text-white/40">Contact</p>
            <div className="space-y-4">
              <a href="tel:5044352757" data-testid="footer-phone" className="flex items-center gap-3 text-white/80 transition-colors hover:text-primary">
                <Phone className="h-4 w-4 text-primary" /> 504-435-2757
              </a>
              <a href="mailto:stormsrs@outlook.com" data-testid="footer-email" className="flex items-center gap-3 text-white/80 transition-colors hover:text-primary">
                <Mail className="h-4 w-4 text-primary" /> stormsrs@outlook.com
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-6 text-white/40">Main Office</p>
            <div className="flex items-start gap-3 text-white/80">
              <MapPin className="mt-1 h-4 w-4 shrink-0 text-primary" />
              <span className="leading-relaxed">
                3327 Pontchatrain Dr.
                <br />
                Slidell, LA 70458
              </span>
            </div>
          </div>
        </div>

        {/* Massive brand text */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="mt-24 border-t border-white/10 pt-10"
        >
          <h2 className="font-display leading-none text-white text-[15vw] tracking-tight md:text-[13vw]">
            STORM<span className="text-primary">&apos;</span>S ROADSIDE
          </h2>
        </motion.div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 text-xs text-white/40 md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} Storm&apos;s Roadside. All rights reserved.</span>
          <span>Slidell, Louisiana</span>
        </div>
      </div>
    </footer>
  );
}
